export default __webpack_public_path__ + "static/media/dummyTeacher.7b1c6585.png";